import { ECollectionStatus } from './contentManagement.interface';

export enum ECollectionItemType {
  ContentLink = 'ContentLink',
  Material = 'Material',
  Course = 'Course',
}

export interface ICollection {
  category: {
    category: string;
    id: number;
    name: string;
  };
  collectionId: string;
  description: string;
  isOwner: boolean;
  items: {
    id: string;
    itemId: string;
    link: string | null;
    name: string;
    order: number;
    owner: {
      academicRank: string | null;
      avatar: string | null;
      name: string;
      profileUrl: string;
    };
    type: ECollectionItemType;
  }[];
  name: string;
  owner: {
    academicRank: string | null;
    avatar: string;
    // id: string;
    name: string;
    profileUrl: string;
  };
  status: ECollectionStatus;
  thumbnailUrl: string;
  totalItems: number;
}

export interface ICollectionItem {
  collectionId: string;
  description: string;
  isOwner: boolean;
  name: string;
  owner: {
    academicRank: string;
    avatar: string;
    id: string;
    name: string;
    profileUrl: string;
  };
  thumbnailUrl: string;
  totalItems: number;
}

export interface ICollectionsResponse {
  collections: Array<ICollectionItem>;
}

export interface ICollectionAvailableDocument {
  id: string;
  name: string;
  thumbnailUrl: string;
}
